const DashboardIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clip-path='url(#clip0_74714_2604)'>
        <path
          d='M10.4005 10.4C9.51686 10.4 8.80054 11.1163 8.80054 12V14.4C8.80054 15.2837 9.51686 16 10.4005 16H10.4197C11.4222 16 12.2825 15.9474 13.0012 15.7876C13.7291 15.6259 14.3601 15.3439 14.8522 14.8517C15.3444 14.3595 15.6264 13.7286 15.7881 13.0007C15.8615 12.6706 15.9099 12.3355 15.9417 11.9983C16.0246 11.1186 15.2842 10.4 14.4005 10.4H10.4005Z'
          fill='black'
        />
        <path
          d='M0.000244141 10.4192V8.79995C0.000244141 7.91627 0.716588 7.19995 1.60024 7.19995H5.60024C6.48392 7.19995 7.20024 7.91627 7.20024 8.79995V14.4C7.20024 15.2836 6.48392 16 5.60024 16H5.58104C4.57854 16 3.71834 15.9473 2.99956 15.7876C2.27171 15.6258 1.64076 15.3438 1.14859 14.8516C0.656412 14.3595 0.37442 13.7285 0.21266 13.0006C0.0529162 12.2819 0.000244141 11.4216 0.000244141 10.4192Z'
          fill='black'
        />
        <path
          d='M16.0005 7.2C16.0005 8.08368 15.2842 8.8 14.4005 8.8H10.4005C9.51686 8.8 8.80054 8.08368 8.80054 7.2V1.6C8.80054 0.716344 9.51686 0 10.4005 0H10.4197C11.4222 0 12.2825 0.0526721 13.0012 0.212416C13.7291 0.374176 14.3601 0.656168 14.8522 1.14834C15.3444 1.64052 15.6264 2.27146 15.7881 2.99932C15.9479 3.7181 16.0005 4.5783 16.0005 5.5808V7.2Z'
          fill='black'
        />
        <path
          d='M7.20073 1.6C7.20073 0.716344 6.48441 0 5.60073 0H5.58153C4.57902 0 3.71882 0.0526721 3.00005 0.212416C2.27219 0.374176 1.64125 0.656168 1.14907 1.14834C0.656896 1.64052 0.374904 2.27146 0.213144 2.99932C0.139776 3.32944 0.0913596 3.6645 0.0595756 4.00168C-0.0233444 4.88144 0.717072 5.6 1.60073 5.6H5.60073C6.48441 5.6 7.20073 4.88366 7.20073 4V1.6Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_74714_2604'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DashboardIcon;
